<template>
  <div class="collapse-item">
    <template v-if="handler.mode === 'flat'">
      <field-item
          v-if="handler.allowObjectModelSelection"
          :disabled="handler.isDisabled(objectModelDataSection.objectModel, objectModelContext)"
          @click="select(objectModelDataSection.select(objectModel, path))"
      >
      <row>
        <prefix>
          <icon glyph="object-model"/>
        </prefix>
        <column>
          {{ objectModelDataSection.objectModel.title }}
        </column>
      </row>

      </field-item>

      <button
          data-toggle="collapse"
          :href="`#objectModelPropertiesCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
          role="button"
          :aria-expanded="propertiesIsOpen.toString()"
          aria-controls="objectModelPropertiesCollapse"
          :class="{collapsed: !propertiesIsOpen}">
        {{handler.header}}
      </button>
      <div class="collapse" :class="{show: propertiesIsOpen}" :id="`objectModelPropertiesCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`">
        <template v-if="modeIs('select')">
          <field-item
              v-for="prop in handler.objectModelPropertiesSection(lowerQ, objectModel).properties"
              :key="prop.clientIdOrId"
              :disabled="handler.isDisabled(prop, computedChildTreeContext)"
              @click="select(handler.objectModelPropertiesSection(lowerQ, objectModel).select(prop, objectModel, completePathFor(prop)))"
          >
            <row>
              <prefix>
                <icon :glyph="ObjectModelPropertyDefinition.getIcon(prop.elementType)"/>
              </prefix>
              <column>
                {{prop.labelTitleDisplay}}
              </column>
            </row>
          </field-item>
        </template>
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import handlerComponentsMixin from '../mixins/handlerComponentsMixin';
  import ProcessFlowObjectModelDynamicFieldsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowObjectModelDynamicFieldsHandler";
  import ObjectModel from "~/models/objectModel";
  import FieldItem from './common/field-item.vue';
  import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
  import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
  import {ReferenceNodeType} from "~/enums/referenceNodeType";
  import {IDynamicTreeContext, IObjectModelDataSection} from "~/interfaces/dynamicFieldsInterfaces";
  import handlerTreeContextMixin from "~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin";
  import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";

  export default Vue.extend({
    mixins: [handlerComponentsMixin, handlerTreeContextMixin],
    components: {
      FieldItem,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowObjectModelDynamicFieldsHandler,
        required: true,
      },
      objectModel: {
        type: Object as () => ObjectModel,
        required: true,
      },
      level: {
        type: Number,
        default: 1,
      },
      defaultOpen: {
        type: Boolean,
        default: false,
      },
      path: {
        type: Array as () => ReferencePathNode[],
        required: false,
      },
    },
    data: function () {
      return {
        ObjectModelPropertyDefinition: ObjectModelPropertyDefinition,
      };
    },
    computed: {
      objectModelDataSection(): IObjectModelDataSection {
        return this.handler.objectModelDataSection(this.lowerQ, this.objectModel);
      },
      propertiesIsOpen(): boolean {
        return (this.defaultOpen && !this.hasSearched) || this.isOpen(this.handler.hasObjectModelPropertyMatch(this.lowerQ, this.objectModel));
      },
      treeContext(): IDynamicTreeContext {
        return {
          parent: this.objectModel,
          isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.objectModel, this.parentTreeContext),
          referencePathNodesToLevel: this.path,
        }
      },
      objectModelContext(): IDynamicTreeContext {
        return {
          ...this.parentTreeContext,
          referencePathNodesToLevel: this.path,
        };
      },
    },
    methods: {
      completePathFor(prop: ObjectModelProperty): ReferencePathNode[] {
        if (!this.path) return null;
        return [
            ...this.path,
            new ReferencePathNode(null, {reference_type: ReferenceNodeType.ObjectModelProperty, reference_id: prop.id}),
        ]
      },
    },
  });
</script>